import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../assets/css/news-details.css";

const NewsDetails = () => {
    const { slug } = useParams();
    const [news, setNews] = useState();
    const [loading, setLoading] = useState(true);
    const API_URL = process.env.REACT_APP_BKND_URL;
    useEffect(() => {
        fetch(
            `${API_URL}/get-blogs.php?type=news&slug=${slug}`
        )
            .then((response) => response.json())
            .then((data) => {
                if (data.status && data.data.length > 0) {
                    setNews(data.data[0]);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.log("News API Error:", error);
                setLoading(false);
            });
    }, [slug]);

    if (loading) {
        return (
            <div className="container py-5 text-center">
                <div className="spinner-border text-danger" role="status">
                    <span className="visually-hidden">
                        Loading...
                    </span>
                </div>
            </div>
        );
    }
    if (!news) {
        return <div className="container py-5">News not found</div>;
    }

    return (
        <div className="news-details-page">
            <div className="container">
                <div className="news-details-card">
                    {/* IMAGE */}
                    <div className="news-image-wrapper">
                        <img
                            src={news.image_url}
                            alt={news.title}
                            className="news-main-image"
                        />
                    </div>
                    {/* CONTENT */}
                    <div className="news-content">
                        <h1 className="news-title">
                            {news.title}
                        </h1>
                        <div className="news-meta">
                            <span>
                                {news.publish_date}
                            </span>
                        </div>
                        {/* TEASER */}
                        {news.content && (
                            <div
                                className="news-teaser"
                                dangerouslySetInnerHTML={{
                                    __html: news.content,
                                }}
                            ></div>
                        )}
                     </div>
                </div>
            </div>
        </div>
    );
};
export default NewsDetails;
